<template>
	<v-container>
		<v-form ref="form" v-model="valid" @submit.prevent="dialogSend = true">
			<v-row class="contentRow">
				<v-col cols="12">
					<h2 class="text-center">Please consider about the following Improvements and Nonconformities before the deadline</h2>
				</v-col>
			</v-row>
			<div class="contentRow" style="border: 5px solid #4CAF50">
				<v-col>
					<h3>Nonconformities (NCR)</h3>
				</v-col>
				<v-col cols="12">
					<v-simple-table>
						<thead>
							<tr>
								<th class="headers">Number</th>
								<th class="headers">Item</th>
								<th class="headers">Subject</th>
								<th class="headers">Observation</th>
								<th class="headers">Deadline</th>
							</tr>
						</thead>
						<tbody v-if="nonconformities.length === 0">
							<tr>
								<td colspan="5" class="text-center no-data-message">
									<p>No nonconformities available.</p>
								</td>
							</tr>
						</tbody>
						<tbody v-for="(entry, index) in nonconformities" :key="'ncr' + index">
							<tr>
								<td><p>{{ index + 1 }}</p></td>
								<td><p>{{ displayValue(entry.Item) }}</p></td>
								<td><p>{{ displayValue(entry.Subject) }}</p></td>
								<td><p>{{ displayValue(entry.Observation) }}</p></td>
								<td><p>{{ formatDate(entry.Deadline) }}</p></td>
							</tr>
							<tr>
								<td colspan="5" v-if="!entry.Answer">
									<v-row dense align="stretch" class="pa-0">
										<v-col cols="7">
											<v-text-field
												v-model="entry.action"
												dense
												outlined
												placeholder="Corrective action"
												hide-details
												full-width
											></v-text-field>
										</v-col>
										<v-col cols="3">
											<v-file-input
												outlined
												accept=".pdf"
												label="Upload Proof (PDF only)"
												v-model="entry.file"
												hide-details
												dense
											></v-file-input>
										</v-col>
										<v-col cols="2">
											<v-btn 
												color="success" 
												:disabled="!canSave(entry)"
												@click="addAction(entry)">Complete<v-icon right small>fas fa-check</v-icon>
											</v-btn>
										</v-col>
									</v-row>
									<v-alert v-if="errorMessage" type="error" class="ml-8">{{ errorMessage }}</v-alert>
								</td>
								<td colspan="5" v-else style="border: 1px solid #1e7c83; padding: 8px; border-radius: 5px; background-color: #eaeaea;">
									<p style="color:#1e7c83; margin: 2px 0;"><i>Corrective Action :-</i></p>
									<p style="margin: 2px 0;"><i>{{ entry.Answer }}</i></p>
									<v-btn class="primary" 
										v-if="entry.FileName" 
										small 
										style="float: right" 
										@click="downloadFiles(entry.ID, entry.FileName)"><v-icon left small>fas fa-download</v-icon>Proofs
									</v-btn>
								</td>
							</tr>
							<td colspan="5"><v-divider class="my-1" style="border: 1px solid #1e7c83"></v-divider></td>
						</tbody>
					</v-simple-table>
				</v-col>
			</div>
			<div class="contentRow" style="border: 5px solid #4CAF50">
				<v-col>
					<h3>Improvements (OFI)</h3>
				</v-col>
				<v-col cols="12">
					<v-simple-table>
						<thead>
							<tr>
								<th class="headers">Number</th>
								<th class="headers">Item</th>
								<th class="headers">Subject</th>
								<th class="headers">Observation</th>
								<th class="headers">Deadline</th>
							</tr>
						</thead>
						<tbody v-if="improvements.length === 0">
							<tr>
								<td colspan="5" class="text-center no-data-message">
									<p>No Improvements available.</p>
								</td>
							</tr>
						</tbody>
						<tbody v-for="(entry, index) in improvements" :key="'ofi' + index">
							<tr>
								<td><p>{{ index + 1 }}</p></td>
								<td><p>{{ displayValue(entry.Item) }}</p></td>
								<td><p>{{ displayValue(entry.Subject) }}</p></td>
								<td><p>{{ displayValue(entry.Observation) }}</p></td>
								<td><p>{{ formatDate(entry.Deadline) }}</p></td>
							</tr>
							<tr>
								<td colspan="5" v-if="!entry.Answer">
									<v-row dense>
										<v-col cols="7">
											<v-text-field
												v-model="entry.action"
												dense
												outlined
												placeholder="Corrective action"
												hide-details
												full-width
											></v-text-field>
										</v-col>
										<v-col cols="3">
											<v-file-input
												outlined
												accept=".pdf"
												label="Upload Proof (PDF only)"
												v-model="entry.file"
												hide-details
												dense
											></v-file-input>
										</v-col>
										<v-col cols="2" class="d-flex align-center">
											<v-btn 
												color="success" 
												:disabled="!canSave(entry)"
												@click="addAction(entry)">Complete<v-icon right small>fas fa-check</v-icon>
											</v-btn>
										</v-col>
									</v-row>
									<v-alert v-if="errorMessage" type="error" class="ml-8">{{ errorMessage }}</v-alert>
								</td>
								<td colspan="5" v-else style="border: 1px solid #1e7c83; padding: 8px; border-radius: 5px; background-color: #eaeaea;">
									<p style="color:#1e7c83; margin: 2px 0;"><i>Corrective Action :-</i></p>
									<p style="margin: 2px 0;"><i>{{ entry.Answer }}</i></p>
									<v-btn class="primary" 
										v-if="entry.FileName" 
										small 
										style="float: right" 
										@click="downloadFiles(entry.ID, entry.FileName)"><v-icon left small>fas fa-download</v-icon>Proofs
									</v-btn>
								</td>
							</tr>
							<td colspan="5"><v-divider class="my-1" style="border: 1px solid #1e7c83"></v-divider></td>
						</tbody>
					</v-simple-table>
				</v-col>
			</div>
		</v-form>
	</v-container>
</template>

<script>
import AuditsAPI from "../../api/audit/audit"
import FilesAPI from "../../api/files/files"
import LoadingState from "../../consts/LoadingState"
export default {
	name: "OnsiteAuditImprovements",
	data() {
		return {
			valid: true,
			dialogSend: false,
			auditId: null,
			nonconformities: [],
			improvements: [],
			errorMessage: "",
		}
	},
	mounted() {
		this.auditId = Number(this.$route.params.id)
		this.loadImprovements()
	},
	methods: {
		displayValue(val) {
			return val === null || val === undefined || val === "" ? "-" : val
		},
		loadImprovements() {
			AuditsAPI.getImprovements()
				.then((result) => {
					const filterResult = result.filter((entry) => entry.AuditID === this.auditId)
					this.nonconformities = filterResult.filter((e) => e.NCRorOFI === 0)
					this.improvements = filterResult.filter((e) => e.NCRorOFI === 1)
				})
				.catch((reason) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		formatDate(timestamp) {
			return timestamp ? this.$moment(timestamp).format("YYYY-MM-DD") : "-"
		},
		canSave(entry) {
			const file = entry.file
			return (entry.action && file && file.type === "application/pdf")
		},
		addAction(entry) {
			const file = entry.file
			if (!file || file.size > 5242880) {
				this.errorMessage = "Please upload a PDF file that is 5MB or smaller"
				return
			}

			const fileName = file.name.replace(/\.[^/.]+$/, "")

			AuditsAPI.updateImprovement(entry.ID, entry.action, fileName, file)
				.then(() => {
					this.$store.dispatch("loading/" + LoadingState.ACTION_LOADING_SUCCESS, "Corrective action saved.", { root: true })
					window.location.reload()
				})
				.catch(error => {
					this.$store.dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, { root: true })
				})
		},
		downloadFiles(fileID, filename) {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Downloading file...",
				{ root: true }
			)
			FilesAPI.downloadOnsiteProofs("" + fileID, filename)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"File was successfully downloaded!",
						{ root: true }
					)
				})
				.catch(err => {
					console.error(err)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						err,
						{
							root: true
						}
					)
				})
		},
	},
}
</script>

<style scoped>
.contentRow {
  margin-top: 20px;
  padding: 10px;
}
.contentRow .headers{
	font-size: 15px;
	color: #1e7c83 !important;
}
</style>